import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css';
import ParentContextProvider from './context/ParentContext';
import DoctorContextProvider from './context/DoctorContext';

const root = createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ParentContextProvider>
      <DoctorContextProvider>
      <App />
      </DoctorContextProvider>
    </ParentContextProvider>
  </Router>
);
